import { render, staticRenderFns } from "./ttshop_mycollection.vue?vue&type=template&id=8e6fee46&scoped=true&"
import script from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
export * from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_mycollection.vue?vue&type=style&index=0&id=8e6fee46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6fee46",
  null
  
)

export default component.exports